const checkWindowExists = (): boolean => typeof window !== 'undefined'
const checkDocumentExists = (): boolean => typeof document !== 'undefined'

export { checkWindowExists, checkDocumentExists }
